import { extendTheme } from "@chakra-ui/react";
import theme from "@metapages/metaframe-chakra-theme";

export const mfTheme = extendTheme(theme);
